import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import LandingPage from './pages/LandingPage';
import AuthCallback from './pages/AuthCallback';
import Analytics from './pages/Analytics';
import TaskManager from './pages/TaskManager';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Contact from './pages/Contact';
import { ThemeProvider } from './components/theme-provider';
import { Toaster } from './components/ui/toaster';
import NavigationHandler from './components/NavigationHandler';
import { Analytics as VercelAnalytics } from '@vercel/analytics/react';
import './App.css';

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="job-tracker-theme">
      <AuthProvider>
        <Router>
          <NavigationHandler />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            } />
            <Route path="/tasks" element={
              <ProtectedRoute>
                <TaskManager />
              </ProtectedRoute>
            } />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          {/* Toast notifications */}
          <Toaster />
          {/* Vercel Analytics */}
          <VercelAnalytics />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
